export const pwaConfig = Object.freeze({
  appName: "StarLive",
  themeColor: "#07090d",
  backgroundColor: "#07090d",
  installGuide: {
    enabled: true,
    intervalDays: 7,
    autoOpenDelayMs: 1600
  },
  ios: { enabled: true },
  android: { enabled: true },
  update: {
    autoCheck: true,
    checkIntervalMs: 60 * 60 * 1000
  },
  serviceWorker: {
    enabled: true,
    path: "/sw.js",
    scope: "/"
  }
})

export default pwaConfig
